import type {
	CreateInsuranceFormData,
	InsuranceWithGroup,
} from "@/types/insurance/insurance";
import type { CreateParameterFormData } from "@/types/parameter/parameter";

/**
 * Aligns a customer's saved insurance row with the catalog template's parameter
 * *types* (same rules as `refreshProductParameters` in the account store):
 * keeps existing params still in the catalog, appends clones for new types,
 * drops types no longer in the catalog.
 */
export const mergeInsuranceParamsWithCatalogTemplate = (
	row: Pick<InsuranceWithGroup, "params">,
	template: CreateInsuranceFormData,
): CreateParameterFormData[] => {
	const templateParams = template.parameters ?? [];
	const existingByType = new Map(
		(row.params ?? []).map((p) => [p.type, p] as const),
	);

	return templateParams.map((templateParam) => {
		const existing = existingByType.get(templateParam.type);
		if (existing) {
			return { ...existing, error: null } as CreateParameterFormData;
		}
		return structuredClone(templateParam) as CreateParameterFormData;
	});
};
